/**
 * src/features/router/router.utils.js
 * 
 * Utilidades para el router (matching de rutas)
 */

import {
    routes
} from './routes.config.js'

export function matchRoute(path) {
    for (const route of routes) {
        const paramNames = []

        // Convertir la ruta de parámetros (ej. '/products/:id') a una expresión regular
        const regexPath = route.path
            .replace(/:(\w+)/g, (_, paramName) => {
                paramNames.push(paramName)
                return '([^\\/]+)' // Captura cualquier cosa que no sea una barra
            })
            .replace('*', '(.*)') // Soporte para wildcard

        const regex = new RegExp(`^${regexPath}$`)
        const match = path.match(regex)

        if (match) {
            // Extraer los parámetros capturados
            const params = paramNames.reduce((acc, name, index) => {
                acc[name] = match[index + 1] // El primer match es la URL completa
                return acc
            }, {})

            return {
                component: route.component,
                params,
                name: route.name
            }
        }
    }

    return null
}

export function parseQueryParams(url) {
    const queryString = url.split('?')[1]
    if (!queryString) return {}

    return queryString.split('&').reduce((acc, param) => {
        const [key, value] = param.split('=')
        acc[decodeURIComponent(key)] = decodeURIComponent(value || '')
        return acc
    }, {})
}

export function buildQueryString(params) {
    const entries = Object.entries(params)
    if (entries.length === 0) return ''

    const query = entries
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&')

    return `?${query}`
}